import React, { Component } from 'react';
import './PatientsBoard.css';
import Aux from "../../hoc/Aux/Aux";
import axios from '../../axios-cmk';
import { Col, Container, Form, FormGroup, Input, Row } from "reactstrap";
import { findPatients, hidePatientDetails, loadPatientDetails, updatePatient } from "../../store/actions";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";
import { baseMapping } from "../../store/mappings";
import { connect } from "react-redux";


class PatientsBoard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedPatient: ''
        }
    }

    componentWillMount() {
        this.timeoutId = 0;
    }

    handlePatientChange = (value) => {
        this.setState({
            selectedPatient: value
        })
    };

    handlePatientInputChange = (event) => {
        const value = event.target.value;
        if (value) {
            clearTimeout(this.timeoutId);
            this.timeoutId = setTimeout(() => {
                this.props.findPatients(value);
            }, 150);
        }
    };

    onMouseEnter = (event) => {
        const target = event.target;
        event.preventDefault();
    };

    render() {
        const results_list = this.props.patients.map(patient => {
            return (
                <div key={patient.id} className="patientResult" onMouseEnter={this.onMouseEnter}>
                    <div>{patient.label}</div>
                </div>
            )
        });
        return (
            <Aux>
                <Container fluid>
                    <div className='row-fluid'>
                        <Col xl={3} className='searchPanel'>
                            <Row>
                                <Form className='searchClient'>
                                    <FormGroup>
                                        <Input
                                            name="form-field-name"
                                            placeholder="Zacznij wpisywać nazwisko pacjenta"
                                            onInputChange={this.handlePatientInputChange}
                                            onChange={this.handlePatientInputChange}
                                        />
                                    </FormGroup>
                                </Form>
                            </Row>
                            <Row>
                                {results_list}
                            </Row>
                        </Col>
                        <Col />
                    </div>
                </Container>
            </Aux>
        )
    }

}

const mapDispatchToProps = dispatch => {
    return {
        loadPatientDetails: (patient_id) => dispatch(loadPatientDetails(patient_id)),
        hidePatientDetails: () => dispatch(hidePatientDetails()),
        updatePatient: (patient_id, patientData) => dispatch(updatePatient(patient_id, patientData)),
        findPatients: (query) => dispatch(findPatients(query))
    }
};

export default connect(baseMapping, mapDispatchToProps)(withErrorHandler(PatientsBoard, axios));


// WEBPACK FOOTER //
// ./src/containers/Patients/PatientsBoard.js